import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';
import {Translate} from 'views/module';

import moment from 'moment-timezone';

const SlipPaymentDetails = (props) => {
  const {hourlyRate, currentShift} = props;

  const start = moment(currentShift.roundedIn);
  const end = moment(currentShift.roundedOut);

  const hoursRaw = end.diff(start, 'hours', true);

  // Round
  const roundedHours = Math.ceil(hoursRaw * 100) / 100;
  const duration = moment.duration(roundedHours, 'hours');
  const totalCost = roundedHours * hourlyRate;

  const hours = duration.hours();
  const minutes = Math.abs(duration.minutes()).toString().padStart(2, '0');
  const formattedDuration = `${hours}:${minutes} h`;

  return (
    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', px: 0.5}}>
      {/* Left: Bold time */}
      <Typography variant='h6' sx={{fontWeight: 700}}>{formattedDuration}</Typography>

      {/* Right: hourly rate (small, grey) and big total */}
      <Box sx={{textAlign: 'right'}}>
        <Typography variant='body2' color='text.secondary'>
          <Translate
            expression='caregiver.CaregiverDetail.Payment.WorkSummary.HoursWorked.HourlyRate'
            substitute={{hourlyRate: Number(hourlyRate).toFixed(2)}}
          />
        </Typography>
        <Typography variant='h6' sx={{fontWeight: 700}}>
          <Translate
            expression='caregiver.CaregiverDetail.Payment.CostDisplay'
            substitute={{cost: totalCost.toFixed(2)}}
          />
        </Typography>
      </Box>
    </Box>
  );
};

SlipPaymentDetails.propTypes = {
  hourlyRate: PropTypes.number.isRequired,
  currentShift: PropTypes.object.isRequired,
  endTime: PropTypes.string.isRequired,
};

export default React.memo(SlipPaymentDetails);
